var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('product-variant-dropdown-base',{attrs:{"label":"GRÖSSE","disable-open":""},scopedSlots:_vm._u([{key:"display-content",fn:function(){return [_c('skeleton-pane',{staticClass:"h-6 w-8"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }